import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import SingleRow from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/index.web';
import getSingleRowStyles from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/styles/index.web';
import Packshot from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/index.web';
import getPackshotStyles from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/styles/index.web';
import { defaultRenderProgressBar } from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/components';
import ModalPicker from '@24i/nxg-sdk-gluons/src/components/inputs/ModalPicker';
import useContinueWatchingQuery from '@24i/nxg-sdk-smartott/src/hooks/query/continueWatching/useContinueWatchingQuery';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { SOTT_DEFAULT_WEB_SCREENS } from '@24i/nxg-sdk-smartott/src/navigation/constants';
import { modalType } from '@24i/player-ui';
import { ASSET_TYPE } from '@24i/nxg-sdk-photon';
import { SectionWrapper, getSectionWrapperStyles } from '@24i/nxg-sdk-smartott-shared';
import { CloseButton } from '../../components/CloseButton';
import { Container, getSeasonPickerStyles, PackshotHolder } from './styled';
import { getSectionWrapperModalStyles } from '../shared/modalStyles';
const PACKSHOT_WIDTH = 248;
const PACKSHOT_HEIGHT = 139;
export const EpisodesModal = ({ className = '', playerInstance, seriesData, }) => {
    var _a;
    const { t } = useTranslation(['sott']);
    const router = useRouter();
    const isNewsEpisode = ((_a = seriesData === null || seriesData === void 0 ? void 0 : seriesData.series) === null || _a === void 0 ? void 0 : _a.type) === ASSET_TYPE.NEWS_SERIES;
    const { data: continueWatchingPlaylist } = useContinueWatchingQuery();
    const [selectedSeason, setSelectedSeason] = useState(null);
    const progress = useMemo(() => {
        if (!playerInstance) {
            return 0;
        }
        const { currentTime, duration } = playerInstance;
        return currentTime / duration;
    }, [playerInstance]);
    const { seasons } = seriesData;
    const currentSeason = Number.isFinite(selectedSeason)
        ? seasons[selectedSeason]
        : seasons.find(({ isCurrent }) => isCurrent);
    const { episodes } = currentSeason;
    const { currentEpisode } = seriesData;
    const { theme } = useTheme();
    const styles = getSeasonPickerStyles(theme);
    const sectionWrapperStyles = getSectionWrapperStyles(theme, {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        between: 12,
    });
    return (React.createElement(Container, { className: `Episodes-Modal ${className}` },
        React.createElement("style", null, `
                .single-row-container .swiper-container {
                    overflow: visible;
                }
            `),
        React.createElement(CloseButton, { type: modalType.episodes, testID: "close_episodes_button" }),
        seasons.length > 1 && !!currentSeason.name && (React.createElement(ModalPicker, { selectedValue: currentSeason.name, options: seasons.map((item) => item.name), onValueChange: (index) => setSelectedSeason(index), color: theme.color.textButtonTertiary, theme: theme, additionalContainerStyles: styles.pickerContainer, additionalTextStyles: styles.pickerText, optionsContainerStyles: styles.optionsContainer, viewContainerStyles: styles.viewContainer, isModalOnOpen: false, isDropdown: true, focusEnabled: true, returnIndex: true, iconSize: 20 })),
        React.createElement(SectionWrapper, { title: isNewsEpisode ? t('asset.latest') : t('player.miniEpg.allEpisodes'), spacing: { top: 0, bottom: 0, left: 0, right: 0, between: 12 }, styles: () => getSectionWrapperModalStyles(sectionWrapperStyles), testID: "episodes-modal-section" },
            React.createElement(SingleRow, { showDuration: true, testId: "episodes", onItemPress: (asset, event) => {
                    const eventAsEvent = event;
                    const { type, id, attributionId } = asset;
                    if (eventAsEvent.preventDefault)
                        eventAsEvent.preventDefault();
                    if (eventAsEvent.stopPropagation)
                        eventAsEvent.stopPropagation();
                    if (id === currentEpisode.id)
                        return;
                    const assetLink = SOTT_DEFAULT_WEB_SCREENS.Playback.getLink({
                        type,
                        id,
                    });
                    router.replace({
                        pathname: assetLink.href,
                        query: {
                            attributionId,
                        },
                    }, assetLink.as);
                }, packshotHeight: PACKSHOT_HEIGHT, packshotWidth: PACKSHOT_WIDTH, key: "episodesAssetsRow", section: {
                    items: episodes,
                }, textColor: theme.color.textSecondary, styles: (propsTheme) => {
                    const singleRowStyles = getSingleRowStyles(propsTheme, true);
                    return Object.assign(Object.assign({}, singleRowStyles), { container: Object.assign(Object.assign({}, singleRowStyles.container), { width: '100%', marginHorizontal: 'auto' }) });
                }, renderPackshot: (props) => {
                    var _a;
                    const isCurrentlyPlaying = props.item.id === currentEpisode.id;
                    let itemProgress = 0;
                    if (!isEmpty(continueWatchingPlaylist)) {
                        const cwAsset = continueWatchingPlaylist.find((asset) => asset.id === props.item.id);
                        itemProgress =
                            cwAsset && cwAsset.continueWatchingOffset && cwAsset.duration
                                ? cwAsset.continueWatchingOffset / cwAsset.duration
                                : undefined;
                    }
                    return (React.createElement(PackshotHolder, { isCurrentlyPlaying: isCurrentlyPlaying },
                        React.createElement(Packshot, Object.assign({}, props, { testID: `episode_${props.index}_tile`, styles: (propsTheme) => {
                                const packshotStyles = getPackshotStyles(propsTheme);
                                return Object.assign(Object.assign({}, packshotStyles), { item: Object.assign(Object.assign({}, packshotStyles.item), { overflow: 'visible' }) });
                            }, progress: isCurrentlyPlaying ? progress : itemProgress, renderProgressBar: defaultRenderProgressBar, actionIcon: !isCurrentlyPlaying ? 'play' : undefined, title: props.item.title, subtitle: (_a = props.item.subtitle) !== null && _a !== void 0 ? _a : '' }))));
                } }))));
};
export default EpisodesModal;
//# sourceMappingURL=index.js.map